<!--提醒框-->
<template>
  <transition name="fade">
    <div class="dialog" v-if="isShow" @click="closeWarn">
        <div class="model" v-html="warnText" @click="closeWarn"></div>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
  },
  data(){
      return {
        warnText: "",
        isShow: false,
        isAutoClose: true
      }
  },
  methods: {
    closeWarn(){
        this.isShow = false;
    },
    message(text,flag=true){ 
        this.warnText = text;
        this.isShow = true;
        this.isAutoClose = flag; 
    }
  },
  watch: {
    isShow: {
        handler: function(){
            if(this.isShow && this.isAutoClose){
                setTimeout(()=>{
                    this.closeWarn();
                },1500)
            }
        }
    }
  }
} 
</script>
<style scoped>
.dialog{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    pointer-events: none;
    background-color: transparent !important;
}
.model{
    position: absolute;
    left: 50%;
    top: 50%;
    line-height: 40px;
    min-width: 100px;
    max-width: 500px;
    text-align: center;
    padding: 0 20px;
    transform: translate(-50%,-50%);
    background-color: rgba(0,0,0,.6) !important;
    border-radius: 10px;
    color: #fff;
    pointer-events: initial;
}
.fade-enter-active, .fade-leave-active{
    transition: all 0.5s;
}
.fade-enter, .fade-leave-active{
    opacity: 0;
}
.fade-enter{
    transform: scale(0);
}
</style>



// WEBPACK FOOTER //
// src/components/common/warn.vue